import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { media } from 'src/styles/breakpoints';

export const StyledAppShell = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  background: ${({ theme }) => theme.lightGrey};
`;

export const StyledMainRow = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
  padding: 2rem;
  background: ${({ theme }) => theme.lightGrey};

  ${media.md} {
    gap: 0.75rem;
    padding: 0.75rem;
    padding-right: max(0.75rem, env(safe-area-inset-right));
    padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
    padding-left: max(0.75rem, env(safe-area-inset-left));
  }
`;

export const StyledContent = styled.main`
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const StyledSidebarBackdrop = styled.div<{ $visible: boolean }>`
  display: none;

  ${media.md} {
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};
    position: fixed;
    inset: 0;
    z-index: 200;
    background: ${({ theme }) => theme.modalBackground ?? 'rgba(15, 18, 28, 0.5)'};
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  }
`;

export const StyledLogoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  .logo_image {
    height: 1.5rem;
    width: auto;
  }
`;

export const StyledLogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
  border-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary};
    outline-offset: 2px;
  }
`;

/** Shared page inner padding for route components */
export const StyledPagePanel = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  padding: 2rem;
  background: ${({ theme }) => theme.background};
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  ${media.md} {
    padding: 1rem;
    border-radius: 0.375rem;
  }

  ${media.xs} {
    padding: 0.75rem;
  }
`;

export const StyledSettingsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1rem 2rem;
  margin-top: 1rem;
  border-radius: 1rem;

  & > div {
    flex: 1 1 14rem;
    min-width: min(100%, 14rem);
  }

  ${media.md} {
    flex-direction: column;
    padding: 1rem;
  }
`;

export const StyledTableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-shrink: 0;

  ${media.md} {
    overflow-x: visible;
  }
`;
